const Datastore = require('nedb-promises')

let db = new Datastore({
	filename: 'users.db', // provide a path to the database file 
	autoload: true, // automatically load the database
	timestampData: true // automatically add and manage the fields createdAt and updatedAt
})

export default {
	all: async function() {
		let all = await db.find({})
		return all
	},
	loginUser: async function(payload) {
		let exist = await this.findOne(payload.code, payload.email)
		if(!exist) {
			return {error: 'No se ha registrado', code: 403}
		}

		return exist
	},

	register: async function(payload) {
		let exist = await this.findOne(payload.code)
		if(exist) {
			return exist
		}
		let user = await db.insert(payload)
		return Object.assign(user, {first_login: true})
	},

	findOne: async function(code) {
		return await db.findOne({
			code: code,
		},{})
	},

	setUnlocks: async function (payload) {
		let user = await db.findOne({code: payload.code})
		user.unlocks = payload.unlocks
		return await db.update({ code: user.code}, user)
	}
}

